import { ISearchConfig } from '@/components/page-search/types'

export const searchFormConfig: ISearchConfig = {
  formItems: [
    {
      type: 'input',
      label: '姓名',
      placeholder: '请输入姓名',
      field: 'nickName',
    },
    {
      type: 'input',
      label: '电话',
      placeholder: '请输入电话',
      field: 'phonenumber',
    },
    {
      type: 'select',
      label: '支付状态',
      placeholder: '请选择支付状态',
      field: 'isPay',
      options: [
        {
          label: '已支付',
          value: '1'
        },
        {
          label: '未支付',
          value: '0'
        }
      ] 
    }
  ]
} 